import React from 'react';
import PropTypes from 'prop-types';
import './custom-radio.css';

export default function CustomRadio({
  name,
  value,
  checked,
  onChange,
  label = '',
  disabled = false,
  color = '#2563eb', // default blue
  size = 'md', // sm | md | lg
  className = '',
  ...rest
}) {
  const inputId = `${name}-${value}`;

  return (
    <label
      htmlFor={inputId}
      className={`custom-radio ${size} ${disabled ? 'is-disabled' : ''} ${className}`}
      style={{ '--radio-color': color }}
    >
      <input
        id={inputId}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => !disabled && onChange(e.target.value, e)}
        disabled={disabled}
        {...rest}
      />
      <span className="radio-circle" />
      {label && <span className="radio-label">{label}</span>}
    </label>
  );
}

CustomRadio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};
